const copy = {
  // Header
  nav_inicio: 'Inicio',
  nav_cursos: 'Cursos',
  nav_carrito: 'Carrito',

  // Homepage
  homepage_bienvenida: 'Bienvenido a la Fundación Iberoamericana de Tecnología',
  homepage_subtitulo: 'Impulsando la innovación tecnológica a través de fronteras',
  homepage_mision: 'Nuestra misión es cerrar la brecha de habilidades tecnológicas, impulsar el crecimiento económico y equipar a los estudiantes con las habilidades más demandadas por el mercado laboral actual.',
  homepage_explorar: 'Explorar Cursos',
  homepage_nuestra_mision: 'Nuestra Misión',
  homepage_mision_desc: 'Creemos que la educación tecnológica tiene el poder de transformar vidas y dar forma al futuro. Al nutrir el talento y fomentar la innovación, contribuimos al crecimiento de individuos, industrias y sociedades.',
  homepage_alianzas: 'Alianzas Universitarias',
  homepage_alianzas_desc: 'Establecemos alianzas estratégicas entre universidades líderes en Estados Unidos y universidades en la región iberoamericana.',
  homepage_desarrollo: 'Desarrollo de Cursos',
  homepage_desarrollo_desc: 'Nuestro equipo trabaja de la mano con miembros de la facultad para diseñar y adaptar cursos que se alineen con las demandas de la industria.',
  homepage_empoderamiento: 'Empoderamiento Docente',
  homepage_empoderamiento_desc: 'Empoderamos a los miembros de la facultad con el conocimiento y los recursos para impartir educación tecnológica de vanguardia.',
  homepage_cursos_destacados: 'Cursos Destacados',
  homepage_cursos_destacados_desc: 'Descubre nuestros cursos más populares y comienza tu viaje hacia el éxito profesional.',
  homepage_ver_todos: 'Ver Todos los Cursos',
  homepage_unete: 'Únete a nosotros en este viaje transformador.',
  homepage_unete_desc: 'En la Fundación Iberoamericana de Tecnología, estamos construyendo puentes de conocimiento y oportunidad, conectando a los estudiantes de hoy con las innovaciones del mañana.',

  // Cursos
  cursos_titulo: 'Nuestros Cursos',
  cursos_subtitulo: 'Encuentra el curso perfecto para desarrollar tus habilidades y avanzar en tu carrera profesional.',
  cursos_encontrados: 'cursos encontrados',
  cursos_ver_detalle: 'Ver Detalles',
  cursos_agregar_carrito: 'Agregar al Carrito',
  cursos_lecciones: 'lecciones',
  cursos_duracion: 'duración',
  cursos_nivel: 'Nivel',

  // Detalle de Curso
  detalle_que_aprenderas: 'Lo que aprenderás',
  detalle_requisitos: 'Requisitos',
  detalle_caracteristicas: 'Características del curso',
  detalle_certificado: 'Certificado',
  detalle_acceso_vida: 'Acceso de por vida',
  detalle_si: 'Sí',
  detalle_no: 'No',
  detalle_duracion: 'Duración',
  detalle_lecciones: 'Lecciones',
  detalle_agregar_carrito: 'Agregar al Carrito',
  detalle_precio: 'Precio',

  // Carrito
  carrito_titulo: 'Carrito de Compras',
  carrito_vacio: 'Tu carrito está vacío',
  carrito_vacio_desc: 'Agrega algunos cursos para comenzar tu aprendizaje',
  carrito_explorar: 'Explorar Cursos',
  carrito_subtotal: 'Subtotal',
  carrito_impuestos: 'Impuestos',
  carrito_envio: 'Envío',
  carrito_gratis: 'Gratis',
  carrito_total: 'Total',
  carrito_proceder_pago: 'Proceder al Pago',
  carrito_pago_seguro: 'Pago seguro con SSL',
  carrito_vaciar: 'Vaciar carrito',

  // Checkout
  checkout_titulo: 'Checkout',
  checkout_info_cliente: 'Información del Cliente',
  checkout_nombre: 'Nombre Completo',
  checkout_email: 'Correo Electrónico',
  checkout_telefono: 'Teléfono',
  checkout_metodo_pago: 'Método de Pago',
  checkout_pago_mercadopago: 'Pago Seguro con MercadoPago',
  checkout_pago_mercadopago_desc: 'Tu pago se procesará de forma segura a través de MercadoPago.',
  checkout_resumen: 'Resumen de Pedido',
  checkout_curso: 'Curso',
  checkout_cantidad: 'Cantidad',
  checkout_impuestos: 'Impuestos',
  checkout_total: 'Total',
  checkout_procesar_pago: 'Proceder al Pago',
  checkout_completar_desc: 'Completa tu compra para acceder a tus cursos',
  checkout_procesando: 'Procesando Pago...',

  // Payment Pages
  payment_success_titulo: 'Pago Exitoso',
  payment_success_desc: 'Tu pago se ha procesado correctamente',
  payment_failure_titulo: 'Pago Fallido',
  payment_failure_desc: 'Hubo un problema con tu pago',
  payment_pending_titulo: 'Pago Pendiente',
  payment_pending_desc: 'Tu pago está siendo procesado',

  // Errors
  error_curso_no_encontrado: 'Curso no encontrado',
  error_volver_cursos: 'Volver a los cursos',
  error_nombre_requerido: 'Por favor ingresa tu nombre completo',
  error_email_requerido: 'Por favor ingresa tu correo electrónico',
  error_email_invalido: 'Por favor ingresa un correo electrónico válido',
  error_telefono_requerido: 'Por favor ingresa tu número de teléfono',
  error_carrito_vacio: 'Tu carrito está vacío',
  error_pago_fallido: 'Error al procesar el pago. Por favor intenta de nuevo.',

  // Estadísticas
  stats_cursos_disponibles: 'Cursos Disponibles',
  stats_estudiantes: 'Estudiantes',
  stats_calificacion: 'Calificación Promedio',
  stats_soporte: 'Soporte',

  // Otros
  comun_moneda: 'MXN',
  comun_simbolo: '$',

  // Autenticación
  auth: {
    login: {
      title: "Iniciar sesión",
      subtitle: "Accede a tu cuenta para continuar",
      email: "Correo electrónico",
      password: "Contraseña",
      button: "Iniciar sesión",
      forgot: "¿Olvidaste tu contraseña?",
      noAccount: "¿No tienes cuenta?",
      register: "Regístrate aquí",
      error: "Correo o contraseña incorrectos",
      success: "¡Bienvenido!",
      successCheckout: "¡Perfecto! Ahora puedes continuar con tu compra",
      goToCampus: "Ir al campus",
      logout: "Cerrar sesión",
      moodleUrl: "https://tucampusmoodle.com",
    },
    register: {
      title: "Crear cuenta",
      subtitle: "Regístrate para acceder a los cursos",
      firstName: "Nombre",
      lastName: "Apellidos", 
      email: "Correo electrónico",
      phone: "Teléfono",
      password: "Contraseña",
      confirmPassword: "Confirmar contraseña",
      button: "Crear cuenta",
      hasAccount: "¿Ya tienes cuenta?",
      login: "Inicia sesión aquí",
      error: "Error al crear la cuenta",
      passwordMismatch: "Las contraseñas no coinciden",
      success: "¡Cuenta creada exitosamente!",
      successCheckout: "¡Cuenta creada! Ahora puedes continuar con tu compra",
    },
    passwordReset: {
      title: "Cambiar contraseña",
      subtitle: "Ingresa tu correo para recibir instrucciones",
      email: "Correo electrónico",
      button: "Enviar instrucciones",
      sent: "Si el correo existe, recibirás instrucciones para cambiar tu contraseña",
      back: "Volver al inicio de sesión",
      error: "Error al enviar las instrucciones",
    },
    logout: {
      title: "Cerrar sesión",
      message: "¿Estás seguro de que quieres cerrar sesión?",
      confirm: "Sí, cerrar sesión",
      cancel: "Cancelar",
    },
  },

  // Checkout con autenticación
  checkout: {
    authRequired: {
      title: "Autenticación requerida",
      message: "Debes iniciar sesión o crear una cuenta para continuar con la compra",
      loginButton: "Iniciar sesión",
      registerButton: "Crear cuenta",
    },
  },

  // Dashboard
  dashboard: {
    welcome: "¡Bienvenido",
    subtitle: "Gestiona tu cuenta y accede a tus cursos",
    tabs: {
      account: "Mi cuenta",
      billing: "Facturación",
      content: "Ver contenido",
    },
    account: {
      title: "Información personal",
      subtitle: "Utilice información real, se mostrará en su certificado",
      name: "Nombre",
      lastName: "Apellido", 
      email: "Correo electrónico",
      changePassword: "Cambiar contraseña",
      newPassword: "Nueva contraseña",
      confirmPassword: "Confirmar nueva contraseña",
      save: "Guardar",
    },
    billing: {
      title: "Historial de compras",
      subtitle: "Revisa tus compras y descargas",
      noPurchases: "No has realizado ninguna compra aún",
      noPurchasesDesc: "Explora nuestros cursos y comienza tu aprendizaje",
      exploreCourses: "Explorar cursos",
      orderNumber: "Pedido",
      date: "Fecha",
      total: "Total",
      status: "Estado",
      download: "Descargar factura",
    },
    content: {
      title: "Acceso al campus",
      subtitle: "Accede a tus cursos y materiales de estudio",
      noCourses: "No tienes cursos activos",
      noCoursesDesc: "Compra un curso para acceder al campus de estudio",
      goToCampus: "Ir al campus",
      campusDesc: "Accede a tu campus virtual para continuar con tus cursos",
    },
    stats: {
      courses: "Cursos",
      certificates: "Certificados", 
      progress: "Progreso",
      enrolled: "Inscritos",
      obtained: "Obtenidos",
      completed: "Completado",
    },
  },
};

export default copy; 